import { useMutation } from "@tanstack/react-query";
import { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Estado } from "../../actions/Estado";
import { TipoInsumo } from "../../actions/tipoinsumo";
import style from "../../styles/form.module.css";
import { toast } from "react-toastify";
import { CircleAlert } from "lucide-react";

function ABMInsumos() {
   const token = localStorage.getItem("token");
   const url = process.env.REACT_APP_URL_DIR + "insumo";
   const [cpres, setCpres] = useState(true);
   const estados = Estado();
   const tipoinsu = TipoInsumo();
   const location = useLocation();
   const { state } = location;

   var urlIns = url;
   var metodo = "PUT";
   const navigate = useNavigate();
   const [input, setInput] = useState({
      id_primary: state ? state.id_primary : 0,
      id: state ? state.id : 0,
      companyId: state ? state.companyId : 0,
      descripcion: state ? state.descripcion : "",
      dolar: state ? state.dolar : 0,
      stock: state ? state.stock : 0,
      cod_status: state ? state.cod_status : "1",
      presentacion: state ? state.presentacion : 1,
      consumo: state ? state.consumo : 0.0,
      unimed: state ? state.unimed : 1,
      presdescrip: state ? state.presdescrip : "",
      tipo: state ? state.tipo : 2,
      porcentajeganancia: 2, // es fijo
      titulomedida: "",
   });

   var btnGrabar = true;

   function handleChange(e) {
      e.preventDefault();
      if (e.target.name === "unimed") {
         if (parseInt(e.target.value) === 1) {
            setCpres(true);
         } else {
            setCpres(false);
         }
      }
      setInput({
         ...input,
         [e.target.name]: e.target.value,
      });
   }
   const verConversion = () =>{
      toast.info("Conversión\n\n 5 cm = 0.05 Mts");
   }

   const handleSubmit = (e) => {
      e.preventDefault();
      if (input.unimed > 1) {
         if (input.consumo === "")
            toast.error("Debe ingresar el consumo del insumo");
         if (input.presentacion === "")
            toast.error("Debe ingresar la presentación del insumo");
         if (input.consumo <= 0)
            toast.error("El consumo del insumo debe ser mayor a cero");
         if (input.presentacion <= 0)
            toast.error("La presentación del insumo debe ser mayor a cero");
         if (parseInt(input.consumo) > parseInt(input.presentacion))
            toast.error("El consumo no puede ser mayor a la presentación");
         if (
            input.consumo === "" ||
            input.presentacion === "" ||
            input.consumo <= 0 ||
            input.presentacion <= 0 ||
            parseInt(input.consumo) > parseInt(input.presentacion)
         )
            return;
      }
      if (parseInt(input.unimed) === 1) input.presentacion = 1;
      console.log("input: ", input);
      urlIns = url + `/${input.id}`;
      metodo = "PUT";
      if (input.id === 0) {
         urlIns = url;
         metodo = "POST";
      }

      mutate(input);
      console.log("input: ", input);
      console.log("urlIns: ", urlIns);
      console.log("metodo: ", metodo);
      //    dispatch(AddInsumos(input));
      // } else {
      //    dispatch(UpdateInsumos(input));
      // }
      // window.location.href = "/insumos/insumos";
   };
   const { mutate } = useMutation({
      mutationFn: (newPost) =>
         fetch(urlIns, {
            method: metodo,
            body: JSON.stringify(newPost),
            headers: {
               Authorization: `Bearer ${token}`,
               "Content-Type": "application/json",
            },
         }).then((res) => res.json()),
      onSuccess: () => {
         window.location.href = "/Insumost";
      },
      onError: () => {
         alert("Error");
      },
   });

   console.log("tipoinsu: ", tipoinsu);

   if (parseInt(input.unimed) === 1) input.titulomedida = "Unidad";
   if (parseInt(input.unimed) === 2) input.titulomedida = "Mililitros";
   if (parseInt(input.unimed) === 3) input.titulomedida = "Gramos";
   if (parseInt(input.unimed) === 4) input.titulomedida = "Metros";

   return (
      <>
         <div className={style.container}>
            <div className="bg-white w-90">
               <form
                  onSubmit={(e) => handleSubmit(e)}
                  // className="form-style-Prod"
               >
                  <h1 className="justify-self-center">Datos del Insumo</h1>
                  <br />
                  <div>
                     {input.id !== 0 ? (
                        <div>
                           <span className={style.input_group_text}>
                              Insumo id : {input.id}
                           </span>
                           <br />
                        </div>
                     ) : null}
                  </div>

                  <div className={style.input_group}>
                     <span className={style.input_group_text}>Insumo: </span>
                     <input
                        className={style.input_field}
                        type="text"
                        placeholder="Descripcion Insumo"
                        name="descripcion"
                        value={input.descripcion}
                        onChange={handleChange}
                        required
                     />
                  </div>
                  <div className={style.input_group}>
                     <span className={style.input_group_text}>
                        Presentación:{" "}
                     </span>
                     <input
                        className={style.input_field}
                        type="text"
                        placeholder="Botella, Caja, Bidon..."
                        name="presdescrip"
                        value={input.presdescrip}
                        onChange={handleChange}
                        required
                     />
                  </div>
                  <div className={style.input_group}>
                     <span className={style.input_group_text}>
                        Unidad de medida:
                     </span>
                     <select
                        name="unimed"
                        id="unimed"
                        onChange={(e) => handleChange(e)}
                        value={input.unimed}
                        className={style.input_field}
                     >
                        <option value="0">Seleccionar</option>
                        <option value="1">Unidad</option>
                        <option value="2">Mililitros</option>
                        <option value="3">Gramos</option>
                        <option value="4">Metros</option>
                     </select>
                  </div>
                  {!cpres || input.unimed > 1 ? (
                     <div className={style.input_group}>
                        <span className={style.input_group_text}>
                           Total {input.titulomedida}
                        </span>
                        <label htmlFor="presentacion"></label>&nbsp;
                        <input
                           type="number"
                           id="presentacion"
                           name="presentacion"
                           value={input.presentacion}
                           onChange={handleChange}
                           className={style.input_field_number}
                        />
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        <span className={style.input_group_text}>
                           {input.titulomedida} que se utilizan
                        </span>
                        &nbsp;
                        <label htmlFor="consumo"></label>&nbsp;
                        <input
                           type="number"
                           id="consumo"
                           name="consumo"
                           value={input.consumo}
                           onChange={handleChange}
                           className={style.input_field_number}
                        />{input.unimed ===4 ? (
                           <span style={{marginLeft:"10px",marginTop:"5px"}}>
                              <CircleAlert className="lucideIconWhite" onClick={()=> verConversion()}/>
                           </span>  
                           ) : null}
                     </div>
                  ) : null}
                  {/* {!cpres || input.unimed >1 ? (
                     <div className={style.input_group}>
                        <span className={style.input_group_text}>{input.titulomedida}</span>
                        <label htmlFor="presentacion"></label>
                        <input
                           type="number"
                           id="presentacion"
                           name="presentacion"
                           value={input.presentacion}
                           onChange={handleChange}
                           className={style.input_field_number}
                           required
                        />
                     </div>
                     ):(null)
                  } */}
                  <div className="d-flex p-1">
                     <div className={style.input_group}>
                        <span className={style.input_group_text}>
                           Precio por Unidad:
                        </span>
                        <p className={style.p_group_text}>{input.dolar}</p>
                     </div>
                     {/* </div>
                  <div className="d-flex p-1"> */}
                     <div className={style.input_group}>
                        <span className={style.input_group_text}>Stock:</span>
                        <p className={style.p_group_text}>{input.stock}</p>
                     </div>
                  </div>
                  <div className={style.input_group}>
                     <span className={style.input_group_text}>
                        Tipo de Insumo:
                     </span>
                     <select
                        name="tipo"
                        id="tipo"
                        onChange={(e) => handleChange(e)}
                        value={input.tipo}
                        className={style.input_field}
                     >
                        <option value="0">Seleccionar</option>
                        {tipoinsu &&
                           tipoinsu.map((ins) => {
                              return (
                                 <option
                                    selected
                                    value={ins.id}
                                    key={ins.id}
                                 >{`${ins.nombre}`}</option>
                              );
                           })}{" "}
                     </select>
                  </div>
                  <div className={style.input_group}>
                     <span className={style.input_group_text}>Status:</span>
                     <select
                        name="cod_status"
                        id="cod_status"
                        onChange={(e) => handleChange(e)}
                        value={input.cod_status}
                        className={style.input_field}
                     >
                        <option value="0">Seleccionar</option>
                        {estados &&
                           estados.map((dat) => {
                              return (
                                 <option
                                    selected
                                    value={dat.id}
                                    key={dat.id}
                                 >{`${dat.nombre}`}</option>
                              );
                           })}{" "}
                     </select>
                  </div>
                  <div>
                     {btnGrabar ? (
                        <button className={style.inputBtnNew} type="submit">
                           {state ? "GRABAR" : "AGREGAR"}
                        </button>
                     ) : null}
                     &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                     <button
                        className={style.inputBtnNew}
                        onClick={() => {
                           navigate("/insumost");
                        }}
                     >
                        VOLVER
                     </button>
                  </div>
               </form>
            </div>
         </div>
      </>
   );
}

export default ABMInsumos;
